import styled from 'styled-components';
import { MantraModal } from '../../../../../../Components/Modal';
import { colors } from '../../../../../../globalStyles';

export const IconWrap = styled.span`
  display: inline-flex;
`;

export const InsightsGridDiv = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: 760px) {
    flex-direction: column;
  }
`;

export const InsightsSectionDiv = styled.section`
  flex: 1;
  min-width: 0;
  padding: 18px 22px 22px;

  &:first-child {
    background-color: ${colors.primaryBgAlt};
    border-right: 1px solid ${colors.grey.lightBorder};

    h3 {
      color: ${colors.secondary};
    }
  }

  @media (max-width: 760px) {
    &:first-child {
      border-right: none;
      border-bottom: 1px solid ${colors.grey.lightBorder};
    }
  }

  h3 {
    margin: 0 0 14px;
    font-size: 20px;
    font-weight: 400;
  }
`;

export const SectionBodyDiv = styled.div`
  color: ${colors.text};
  font-size: 14px;
  line-height: 1.6;

  p {
    margin: 0 0 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 700;
  }
`;

export const RecommendationsOl = styled.ol`
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    &::marker {
      font-weight: 700;
    }
  }
`;

export const EmptyStateP = styled.p`
  color: ${colors.grayText};
`;

export const InsightsModal = styled(MantraModal)`
  & > svg {
    fill: ${colors.white};
  }
`;

export const ModalHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  background-color: ${colors.secondary};
  color: ${colors.white};
  font-size: 18px;
  font-weight: 700;
`;

export const ModalBodyDiv = styled.div`
  ${InsightsGridDiv} {
    flex-direction: column;
  }

  ${InsightsSectionDiv} {
    &:first-child {
      background-color: transparent;
      border-right: none;
      border-bottom: none;
    }
  }
`;
